import React, { Component } from "react";
import {
  ColorWrap,
  Saturation,
  Hue,
  Alpha,
} from "react-color/lib/components/common";
import { hex2rgb, rgb2hex } from "./utils";

import {
  WrapperColorPicker,
  LabelHeader,
  LabelTitle,
  LabelOption,
  ColorEntry,
  ColorRef,
  Picker,
  SaturationContainer,
  SliderContainer,
  defaultStyles,
  PickerColor,
  ColorInput,
} from "./styles";

class ColorPicker extends Component {
  constructor() {
    super();
    this.state = {
      hex: "",
      open: false,
    };
    this.colorPickerLabel = React.createRef();
    this.colorPickerRef = React.createRef();
    this.colorPickerLabelText = React.createRef();
    this.colorPickerContainerRef = React.createRef();
  }

  componentDidMount() {
    const { color } = this.props;

    this.setState({
      hex: rgb2hex(color.r, color.g, color.b),
    });
  }

  handlerChange = (e) => {
    const { onChange, color } = this.props;

    this.setState({
      hex: rgb2hex(color.r, color.g, color.b),
    });
    onChange(e);
  };

  inputHandleChange = (e) => {
    const { onChange, color } = this.props;
    const { value } = e.target;

    const newValue = value
      .toUpperCase()
      .replace("#", "")
      .replace(/[^0-9ABCDEF]/g, "")
      .slice(0, 6);

    const rgb = hex2rgb(`#${newValue}`);

    this.setState({
      hex: newValue,
    });

    if (rgb) {
      onChange({
        r: rgb[0],
        g: rgb[1],
        b: rgb[2],
        a: color.a,
      });
    }
  };

  closePicker = (e) => {
    if (!this.colorPickerContainerRef?.current?.contains(e.target)) {
      this.setState({ open: false });
      document.removeEventListener("click", this.closePicker);
    }
  };

  colorPickerHandler = (e) => {
    const { colorPickerLabel, colorPickerRef, colorPickerLabelText } = this;
    const { open } = this.state;

    if (
      e.target === colorPickerLabel.current ||
      e.target === colorPickerRef.current ||
      e.target === colorPickerLabelText.current
    ) {
      this.setState({
        open: !open,
      });
    }

    document.addEventListener("click", this.closePicker);
  };

  render() {
    const {
      rgb,
      hsv,
      hsl,
      renderers,
      color,
      label,
      labelFontSize,
      labelGap,
      resetProps,
    } = this.props;
    const { hex, open } = this.state;

    return (
      <WrapperColorPicker>
        <LabelHeader
          onClick={this.colorPickerHandler}
          ref={this.colorPickerLabel}
          labelGap={labelGap}
        >
          <LabelTitle ref={this.colorPickerLabelText} fontSize={labelFontSize}>
            {label}
          </LabelTitle>

          <LabelOption>
            {resetProps}
            <ColorInput open={open}>
              <ColorRef
                color={color}
                onClick={this.colorPickerHandler}
                ref={this.colorPickerRef}
                id="ColorRef"
              />
              {/* <ColorLabel>HEX#</ColorLabel> */}
              <ColorEntry
                value={`#${hex}`}
                onChange={this.inputHandleChange}
                maxLength={7}
              />
            </ColorInput>
          </LabelOption>
        </LabelHeader>
        <PickerColor
          className={open && "OpenedPicker"}
          open={open}
          id="PickerColor"
        >
          <Picker className="sketch-picker" ref={this.colorPickerContainerRef}>
            <SaturationContainer>
              <Saturation
                style={defaultStyles.Saturation}
                hsl={hsl}
                hsv={hsv}
                color={color}
                onChange={this.handlerChange}
              />
            </SaturationContainer>
            <SliderContainer>
              <Hue
                direction="vertical"
                style={defaultStyles.Hue}
                hsl={hsl}
                onChange={this.handlerChange}
              />
            </SliderContainer>
            <SliderContainer>
              <Alpha
                direction="vertical"
                style={defaultStyles.Alpha}
                rgb={rgb}
                hsl={hsl}
                renderers={renderers}
                onChange={this.handlerChange}
              />
            </SliderContainer>
          </Picker>
        </PickerColor>
      </WrapperColorPicker>
    );
  }
}

export default ColorWrap(ColorPicker);
